import { JackpotType } from '@/types/gameTypes';

import JackpotLayer from './JackpotLayer';
import styles from './JackpotLayerSearch.module.scss';

type JackpotLayerSearchProps = JackpotType;

const GT_JACKPOT_TICKER_TEST_ATTR = 'gt-jackpot_ticker_search';

const JackpotLayerSearch = (jackpot: JackpotLayerSearchProps) => (
  <div className={styles.container} data-testid={GT_JACKPOT_TICKER_TEST_ATTR}>
    <JackpotLayer {...jackpot} componentType={'search'} />
  </div>
);

export default JackpotLayerSearch;
